module.exports = __webpack_public_path__ + "static/media/vg.79b23e76.jpeg";